
import { AssetType } from '../../assettype/model/asset-type.model';
import { MECHANICAL_ASPECT_METADATA } from './mechanical-aspect.metadata';
import { MechanicalAspectBase } from './mechanical-aspect.model.base';
import { CrudEntity, CrudEntityConstructionOptions } from '@scisys-uim/uim-common';


export interface MechanicalAspect extends MechanicalAspectBase {
}

export interface MechanicalAspectTransient { }

export class MechanicalAspect extends CrudEntity<MechanicalAspect, number, MechanicalAspectTransient> implements MechanicalAspectTransient {
  constructor(source?: Partial<MechanicalAspect>, options?: CrudEntityConstructionOptions<MechanicalAspect, number, MechanicalAspectTransient>) {
    super(MECHANICAL_ASPECT_METADATA, source, options);
  }

  initialiseEntityDefaults() {
    super.initialiseEntityDefaults();
  }

  registerPropertyCalculators() {
    super.registerPropertyCalculators();
  }

  setDefaultsForAssetType(assetType: AssetType) {
    if (assetType != null) {
      this.havs = assetType.havs;
      this.havsRagStatus = assetType.havsRagStatus;
      this.wbv = assetType.wbv;
      this.wbvRagStatus = assetType.wbvRagStatus;
    }
  }

  get aspectAssetId() {
    return null;
  }
}





